/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import styled from 'styled-components';
import { NoteBar as NoteBarKit, NOTEBAR_STATUS } from '@veeam/components';
import { colors } from '@veeam/components/lib/themes/colors/colors';

import type { NoteBarProps as NoteBarKitProps } from '@veeam/components';

export interface NoteBarProps extends NoteBarKitProps {
    isBackgroundColored?: boolean;
}

const BACKGROUND_COLOR = {
    [NOTEBAR_STATUS.warning]: colors.Y50,
    default: 'rgb(246, 246, 246)',
};

export const NoteBar = styled(NoteBarKit)<NoteBarProps>`
    background-color: ${props => props.isBackgroundColored && BACKGROUND_COLOR[props.status] || BACKGROUND_COLOR.default};
`;
